import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BatchBrewSheet } from '@/components/recipe/brew-sheet';
import { useReturn } from '@/lib/return-ticket';

export const Route = createFileRoute('/batches/$batchId/sheet')({
  component: BatchBrewSheetPage,
});

function BatchBrewSheetPage() {
  const { batchId } = Route.useParams();
  const navigate = useNavigate();
  // Back to the batch's own entry when the sheet was opened from it — which is
  // still holding the log's ticket, so the press after that reaches the log the
  // beer was opened from (PLAN-LIST-STATE D-LS8). A sheet reached any other way
  // — a bookmark, or the link sent to the machine the printer is on — pushes
  // the batch page.
  const toBatch = useReturn(() => {
    void navigate({ to: '/batches/$batchId', params: { batchId } });
  });
  // Keyed for the reason the batch page is (see `index.tsx`): a sheet reused
  // across a param change would keep what it was holding for the batch before
  // it. Each sheet is a new mount. The batch that is not in this workspace is
  // `BatchBrewSheet`'s own answer, held back until the workspace has settled,
  // so a batch that is merely still arriving never flashes "not found"
  // (PLAN-UX-PASS C9).
  return <BatchBrewSheet key={batchId} batchId={batchId} onBack={toBatch} />;
}
